import * as React from "react";
import BubbleChart from "./BubbleChart";
import financeBuilding from "src/assets/financeBuilding.png";
import SectionHeading from "src/components/general/SectionHeading";
import { defaultYear } from "src/constants/ApiSettings";
import { IConnectedModuleProps, IConnectedModuleState, ICouncil } from "src/interfaces";
import { connect } from "react-redux";

interface IProps extends IConnectedModuleProps {
  councils: ICouncil[];
}

class CouncilRevenue extends React.PureComponent<
  IProps,
  IConnectedModuleState
> {
  constructor(props: IProps) {
    super(props);

    const selectedYear = defaultYear;

    this.state = { selectedYear };
  }

  public handleYearChange = (value: string) => {
    this.setState({ selectedYear: value });
  };

  public render() {
    return (
      <div>
        <div className="w-full" id="revenue">
          <SectionHeading
            heading="This is your council's operating revenue"
            alignment="left"
            yearPicker={ this.handleYearChange }
            year={ this.state.selectedYear }
            learnMore={ "totalOperatingRevenue" }
            councilSays={ "totalOperatingRevenueCouncilSays" }
            inverse={ false }
          />
          <div className="flex">
            <p className="w-full lg:w-2/3 xl:w-2/3 font-montserrat my-6">
              Councils derive revenue from a number of different sources.
              Revenue received directly from council operations includes rates
              and charges, operational grants and subsidies, fees and charges,
              and sales and contract/recoverable works. Operating revenue does
              not include capital revenues such as capital grants and subsidies
              and capital (developer) contributions.
            </p>
            <div className="hidden lg:block xl:block lg:w-1/3 xl:w-1/3 text-center">
              <img
                src={financeBuilding}
                alt="finace"
                width="200"
                height="200"
              />
            </div>
          </div>
        </div>
        <div className="lg:mt-6 lg:mb-6">
          <BubbleChart
            councils={this.props.councils}
            selectedYear={this.state.selectedYear}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  defaultYear:
    state.selectables.years.length > 0 ? state.selectables.years[0] : null,
  councils: state.selected.councils,
});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CouncilRevenue);



// WEBPACK FOOTER //
// ./src/components/report/councilFinances/CouncilRevenue.tsx